export default function PHP_output_add_rewrite_var() {
  return (
    <div>
      <h1>PHP_output_add_rewrite_var</h1>
    </div>
  );
}
